import FilterCategory from './FilterCategory';

export default FilterCategory;
